import { render, staticRenderFns } from "./select-coordinate.vue?vue&type=template&id=5638983f&scoped=true&"
import script from "./select-coordinate.vue?vue&type=script&lang=js&"
export * from "./select-coordinate.vue?vue&type=script&lang=js&"
import style0 from "./select-coordinate.vue?vue&type=style&index=0&id=5638983f&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638983f",
  null
  
)

export default component.exports